import { render, staticRenderFns } from "./ServiceJoinStep2Contentsogmmr.vue?vue&type=template&id=0c29a595"
import script from "./ServiceJoinStep2Contentsogmmr.vue?vue&type=script&lang=js"
export * from "./ServiceJoinStep2Contentsogmmr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c29a595')) {
      api.createRecord('0c29a595', component.options)
    } else {
      api.reload('0c29a595', component.options)
    }
    module.hot.accept("./ServiceJoinStep2Contentsogmmr.vue?vue&type=template&id=0c29a595", function () {
      api.rerender('0c29a595', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/ServiceJoinStep2Contentsogmmr.vue"
export default component.exports